<h2 mat-dialog-title >{{audience.name}}: {{data.filter_keywords.length}} recipients</h2>
<div mat-dialog-content >
    <div class="vp-container">
        <mat-chip-list >
            <mat-chip *ngFor="let tag of data.filter_keywords" >
                {{ tag }}
            </mat-chip>
        </mat-chip-list>
    </div>
</div>